<template>
  <v-container v-if="nets" class="grey lighten-5" fluid>
    <v-row>
      <v-col cols="12" class="pb-0">
        <v-text-field
          outlined
          v-model="searchNameNet"
          label="Filter the Weather Stations by Name or Region"
          ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0">
        <nets-map :nets="filteredNets"/>
      </v-col>
    </v-row>
      <v-row>
        <v-col cols="12" sm="12" >
          <div class="d-flex align-content-start justify-space-around flex-wrap">
            <net-card v-for="net in filteredNets" :net="net" :key="net.nodeId" :withSensors="true"/>
          </div>
        </v-col>
      </v-row>
  </v-container>
</template>
<script>
import api from '@/api'
import NetCard from "../components/NetCard.vue"
import NetsMap from "../components/NetsMap.vue"
export default {
  components: {
    NetCard,
    NetsMap
  },
  data: () => ({
    nets: [],
    searchNameNet: ''
  }),
  computed:{
    filteredNets: function () {
      if (this.searchNameNet=='') { return this.nets }
      return this.nets.filter((net) => net.name.toLowerCase().includes(this.searchNameNet.toLowerCase()) || net.region.toLowerCase().includes(this.searchNameNet.toLowerCase()))
    }
  },
  mounted: async function() {
    try {
      this.nets =( await api.netsdetail()).sort((a, b) => a.region.localeCompare(b.region))
    } catch (error) {
      console.log(error)
      this.$store.commit('logout')
      this.$router.push('Welcome')
    }
  }
}
</script>
